export class Translations {
  private readonly w: { LANG_STRINGS: any } = window as any;

  constructor() {
    this.w = window as any;

    const serverTranslations = this.w.LANG_STRINGS;

    if (serverTranslations) {
      // Assign server translations to our translation object
      Object.assign(this, serverTranslations);
    }
  }

  // Topic page

  // Filters
  FilterTitle!: string;
  FilterMarket!: string;
  FilterModel!: string;
  FilterModelStructureWeek!: string;
  FilterStructureWeek!: string;
  FilterPropulsion!: string;
  FilterElectricCapacity!: string;
  FilterElectricPowertrain!: string;
  FilterSubmit!: string;
  FilterShowNews!: string;
  HeaderFilterChange!: string;
  FilterGearboxValidForTopic!: string;
  FilterGearboxValidFor!: string;
  FilterSelectedConfiguration!: string;
  FilterConfirmChoice!: string;

  // Feedback
  FeedbackButtonText!: string;
  FeedbackTitle!: string;
  FeedbackName!: string;
  FeedbackWorkRole!: string;
  FeedbackArea!: string;
  FeedbackType!: string;
  FeedbackMessage!: string;
  FeedbackAttachFile!: string;
  FeedbackSubmit!: string;
  TopicFeedbackThankYou!: string;
  TopicFeedbackPoisitive!: string;
  TopicFeedbackNegative!: string;

  // Release notes
  ReleaseNotesTitle!: string;
  ReleaseNotesUnsubscribeMessage!: string;
  ReleaseNotesSubscribeMessage!: string;
  ReleaseNotesUnsubscribe!: string;
  ReleaseNotesSubscribe!: string;

  // Search
  SearchGlobalSearchTip!: string;
  SearchMatchResultSingular!: string;
  SearchMatchResultPlural!: string;
  SearchInstructions!: string;
  SearchPlaceholder!: string;
  SearchNoHits!: string;
  SearchPreviousSearches!: string;

  // Print
  PrintBasketTitle!: string;
  PrintBasketEmptyLabel!: string;
  PrintBasketPreview!: string;
  PrintCancel!: string;
  PrintBasketClear!: string;
  PrintTopicMissingWarning!: string;
  PrintRemoveLabel!: string;
  PrintAddLabel!: string;
  PrintToManyTopicsTitle!: string;
  PrintToManyTopicsBody!: string;
  PrintBasketLimitReached!: string;
  PrintBasketLimitWarning!: string;
  InfoboxAccept!: string;
  PrintTopicsMissingPreviewWarning!: string;
  PrintBackLabel!: string;
  PrintDownloadPdf!: string;
  PrintGeneratePdf!: string;
  PrintDownloadWord!: string;
  PrintGenerateWord!: string;

  // Sidebar
  SidebarHeader!: string;

  // Topic
  TopicRelatedArticles!: string;
  TopicFeedbackTitle!: string;
  TopicImageZoomText!: string

  public getLocalizedFilterString(name: string): string {
    const key = `Filter${name}`;
    return this.w.LANG_STRINGS[key] || name;
  }

  public getLocalizedString(name: string): string {
    return this.w.LANG_STRINGS[name] || `[${name}] - Translation missing`;
  }
}

export default new Translations();
